<script>
export default {
  name: 'icon-chatbox',
  props: {
    color: {
      type: String,
      default: '#ffffff',
    },
    page: {
      type: String,
      default: '',
    }
  },
}
</script>

<template>
  <svg v-if="page == 'preview'" id="グループ_146" data-name="グループ 146" xmlns="http://www.w3.org/2000/svg" width="248" height="46" viewBox="0 0 248 46">
    <path id="合体_2" data-name="合体 2" d="M121.46,43.137l-5.5-5.324H18.906A18.906,18.906,0,0,1,18.906,0H229.094a18.906,18.906,0,1,1,0,37.813H129.74l-5.5,5.324a2,2,0,0,1-2.784,0Z" transform="translate(0 2.3)" fill="#fff301"/>
    <path id="合体_1" data-name="合体 1" d="M121.388,42.9l-4.735-5.1H18.9A18.9,18.9,0,0,1,18.9,0H229.1a18.9,18.9,0,1,1,0,37.809H129.052l-4.735,5.1a2,2,0,0,1-2.929,0Z" fill="#fff"/>
  </svg>
  <svg v-else id="グループ_146" data-name="グループ 146" xmlns="http://www.w3.org/2000/svg" width="296" height="45.999" viewBox="0 0 296 45.999">
    <path id="合体_2" data-name="合体 2" d="M145.186,43.549l-6.949-5.658H18.946A18.945,18.945,0,1,1,18.946,0H276.689a18.945,18.945,0,1,1,0,37.891H154.661l-6.949,5.658a2,2,0,0,1-2.525,0Z" transform="translate(0 2)" fill="#fff301"/>
    <path id="合体_1" data-name="合体 1" d="M145.122,42.5l-6.064-5.375H18.561A18.56,18.56,0,1,1,18.561,0H277.075a18.56,18.56,0,0,1,0,37.121H153.84L147.775,42.5a2,2,0,0,1-2.653,0Z" transform="translate(0.365)" fill="#fff"/>
  </svg>


</template>
